import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import { prepareSearchParams } from "@/libs/helper";

const resource = `${Config.basePath}/user/operator`;

export default {
  options(payload) {
    payload.order = "name";
    payload.sort = "asc";
    return Client.get(`${resource}/service`, {
      params: payload,
    });
  },
};
